import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
} from 'react-admin';

export const RewardBonusCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" label="Title" defaultValue="Congratulations!" />

      <TextInput source="subtitle" label="Subtitle" defaultValue="You've Received a New Bonus" />

      <NumberInput source="amount" label="Amount" isRequired />

      <TextInput source="highlight_text" label="Highlight text" />

      <TextInput
        source="description"
        label="Description"
        defaultValue="আপনার বোনাস ক্লেইম করে উপভোগ করুন"
      />

      <TextInput source="button_text" label="Button text" defaultValue="বোনাস ক্লেইম করুন" />

      <TextInput
        source="note_text"
        label="Note text"
        defaultValue="বোনাস আপনার ব্যালেন্সে সাথে সাথে যোগ হবে"
      />

      <ImageInput source="image" label="Image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="background_color" label="Background color" defaultValue="#0F172A" />

      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
    </SimpleForm>
  </Create>
);

// ---------- EDIT ----------
const formatImage = (value) => {
  if (!value) return value;
  if (typeof value === 'string') {
    return { src: value, title: value };
  }
  return value;
};

const parseImage = (value) => {
  if (!value) return null;
  if (value.rawFile) return value;
  return value.src;
};

export const RewardBonusEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" label="Title" />

      <TextInput source="subtitle" label="Subtitle" />

      <NumberInput source="amount" label="Amount" />

      <TextInput source="highlight_text" label="Highlight text" />

      <TextInput source="description" label="Description" />

      <TextInput source="button_text" label="Button text" />

      <TextInput source="note_text" label="Note text" />

      <ImageInput
        source="image"
        label="Image"
        accept="image/*"
        format={formatImage}
        parse={parseImage}
      >
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="background_color" label="Background color" />

      <BooleanInput source="is_active" label="Is active" />
    </SimpleForm>
  </Edit>
);